import { useEffect, useState } from 'react';

import { replace } from 'lodash';
import { RemoteParticipant } from 'twilio-video';

import { formatParticipantName } from '@lib/services/stringsService';

import { useVideoContext } from '../index';

export default function useParticipantStatus() {
  const { room } = useVideoContext();
  const [message, setMessage] = useState<any>({});
  const [subscribed, setSubscribed] = useState(false);

  const handleParticipantSessionStatusChange = (participant: RemoteParticipant, isConnecting: boolean) => {
    setMessage({
      key: `${replace(participant.identity, /\s/gi, '-')}_${
        isConnecting ? 'connected' : 'disconnected'
      }_${new Date().getTime()}`,
      text: `${formatParticipantName(participant.identity)} has ${isConnecting ? 'connected' : 'disconnected'}`,
      type: `status-${isConnecting ? 'connected' : 'disconnected'}`,
    });
  };

  const handleParticipantNewtorkQualityLevelStatusChange = (
    participant: RemoteParticipant,
    networkQualityLevel: number,
  ) => {
    if (networkQualityLevel < 3) {
      setMessage({
        key: `${replace(participant.identity, /\s/gi, '-').toLowerCase()}_poor_connection_${new Date().getTime()}`,
        text: `${formatParticipantName(participant.identity)} connection is slow`,
        type: 'slow-connection',
      });
    }
  };

  useEffect(() => {
    if (!subscribed) {
      setSubscribed(true);

      if (!room) return;

      room.participants.forEach((participant: RemoteParticipant) => {
        participant.on('networkQualityLevelChanged', (networkQualityLevel: number) =>
          handleParticipantNewtorkQualityLevelStatusChange(participant, networkQualityLevel),
        );
      });

      return () => {
        room.participants.forEach((participant: RemoteParticipant) => {
          participant.off('networkQualityLevelChanged', (networkQualityLevel: number) =>
            handleParticipantNewtorkQualityLevelStatusChange(participant, networkQualityLevel),
          );
        });
      };
    }
  }, [subscribed, room]);

  useEffect(() => {
    if (!room) return;

    room.on('participantConnected', (participant: RemoteParticipant) => {
      handleParticipantSessionStatusChange(participant, true);

      participant.on('networkQualityLevelChanged', (networkQualityLevel: number) =>
        handleParticipantNewtorkQualityLevelStatusChange(participant, networkQualityLevel),
      );
    });
    room.on('participantDisconnected', (participant: RemoteParticipant) =>
      handleParticipantSessionStatusChange(participant, false),
    );

    return () => {
      room.off('participantConnected', (participant: RemoteParticipant) => {
        handleParticipantSessionStatusChange(participant, false);

        participant.off('networkQualityLevelChanged', (networkQualityLevel: number) =>
          handleParticipantNewtorkQualityLevelStatusChange(participant, networkQualityLevel),
        );
      });
      room.off('participantDisconnected', (participant: RemoteParticipant) =>
        handleParticipantSessionStatusChange(participant, false),
      );
    };
  }, [room]);

  return message;
}
